<script lang="ts" setup>
import { Text } from '~ds/components/ui/typography';

interface Props {
  text: string;
};

defineProps<Props>();
</script>

<template>
  <div
    class="w-fit rounded-full bg-white px-3 py-1 tracking-tight [filter:drop-shadow(0_2px_2px_rgb(0_0_0/0.1))]"
  >
    <Text class="leading-none text-4xl" weight="semibold">
      {{ text }}
    </Text>
  </div>
</template>
